import React from 'react'
import PropTypes from 'prop-types'

import Slide from '../components/Slide.jsx'
import Footer from '../components/Footer.jsx'

import useRect from '../hooks/useRect.js'

const Image = (props) => {
  const { imageUrl, page, footerTheme } = props

  const [Rect, rect] = useRect()

  return (
    <Slide>
      <Rect />
      <image href={imageUrl} height={rect.height} width={rect.width} x={0} y={0} />
      <Footer
        page={page}
        theme={footerTheme ?? { background: 'dark', icon: 'light', page: 'light' }}
      />
    </Slide>
  )
}

Image.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  page: PropTypes.number.isRequired,
  footerTheme: PropTypes.shape({}),
}

export default Image
